<template lang="pug">
  .bin-input(v-if="bin.showEmail")
    RogueInput(
      type="email"
      label="Email Notification Sign-Up"
      @keyup.enter="$emit('signup')"
      :disabled="bin.loading"
      :placeholder="__('Enter your e-mail address')"
      v-model="bin.email"
    )
    button.link(@click="bin.showEmail = false") {{ __('Cancel') }}
</template>
<script>
export default {
  name  : 'BinEmailInput',
  props : {
    bin: {
      type     : Object,
      required : true,
    },
  },
  emits: ['signup'],
}
</script>
<style lang="scss" scoped>
.bin-input {
  display: flex;
  align-items: center;
  margin-top: $space-xs;

  .field {
    flex-grow: 1;
  }

  .link {
    font-size: $size-xs;
    margin-left: $space-s;
  }
}
</style>
